import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const getHeadlineHasPublication= async (id) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}headline-has-publications/${id}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      console.log('error getHeadlineHasPublication', error.response.data)
      return error
    })
}

export const postHeadlineHasPublication = async (body) => {
  
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }


  return await axios
    .post(`${BASE_URL}headline-has-publications`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      console.log('error postHeadlineHasPublication', error.response.data)
      return error
    })
}

export const getHeadlineHasPublicationByPublicationId = async (publicationId) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}headline-has-publications-by-publication/${publicationId}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log(
        'error getHeadlineHasPublicationByPublicationId',
        error.response.data
      )
      return error
    })
}

